<template>
  <div class="body">
    <el-container>
      <UsersAside @toggle="toggle($event)" />
      <el-main>
        <el-card>
          <el-row :gutter="10">
            <el-col :lg="6">
              <el-select
                style="width: 100%"
                v-model="userID"
                placeholder="اختر مستخدم"
                @change="getLogs"
              >
                <el-option
                  v-for="user in usersList"
                  :key="user.id"
                  :label="user.name"
                  :value="user.id"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :lg="8">
              <el-date-picker
                @change="getLogs"
                v-model="dateRange"
                type="daterange"
                range-separator="الي"
                format="yyyy/MM/dd"
                value-format="yyyy-MM-dd"
                start-placeholder="بداية الفترة"
                end-placeholder="نهاية الفترة"
              >
              </el-date-picker>
            </el-col>
            <el-col :lg="6">
              <el-input
                @change="selectActionToken"
                placeholder="بحث بالبيان"
                autofocus
                type="text"
                @focus="$event.target.select()"
                v-model="actionToken"
              ></el-input>
            </el-col>
          </el-row>
        </el-card>
        <el-table :data="LogsList" border>
          <el-table-column label="#" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            label="رقم العمليه"
            prop="operation_id"
            width="100"
          ></el-table-column>
          <el-table-column
            label="البيان"
            prop="description"
            width="400"
          ></el-table-column>
          <el-table-column label="القيمة" prop="amount"></el-table-column>
          <el-table-column label="بواسطة" prop="user.name"></el-table-column>
          <el-table-column label="التوقيت" prop="created_at">
            <template slot-scope="scope">
              {{ scope.row.created_at | moment(" Do / MM / YYYY | h:mm A") }}
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import UsersAside from "@/components/UsersAside.vue";
import axiosApi from "@/plugins/axios.js";
export default {
  components: { UsersAside },
  data() {
    return {
      activeSide: true,
      LogsList: [],
      usersList: [],
      userID: "",
      dateRange: null,
      actionToken: null,
    };
  },
  methods: {
    getLogs() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = "logs/?limit=20";
      if (this.userID != "") {
        url += `&user=${this.userID}`;
      }
      if (this.dateRange != null) {
        url += "&start=" + this.dateRange[0];
        url += "&end=" + this.dateRange[1];
      }
      axiosApi
        .get(url)
        .then((res) => {
          console.log("logs", res);
          this.LogsList = res.data;
          localStorage.setItem("logs", JSON.stringify(this.LogsList));
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },
    getUsers() {
      axiosApi.get("users").then((res) => {
        console.log("users", res.data.users);
        this.usersList = res.data.users;
      });
    },
    toggle(active) {
      this.activeSide = active;
    },
    selectActionToken() {
      let newData = [];
      let outStockProuducts = JSON.parse(localStorage.getItem("logs"));
      if (this.actionToken !== "") {
        for (let index = 0; index < outStockProuducts.length; index++) {
          if (outStockProuducts[index].description.match(this.actionToken)) {
            newData.push(outStockProuducts[index]);
          }
        }
      } else {
        newData = outStockProuducts;
      }
      this.LogsList = newData;
    },
  },
  mounted() {
    this.getLogs();
    this.getUsers();
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  min-height: 77%;
  max-height: 89%;
  overflow-y: scroll;
}
</style>
